import EnhancementsPage from "../features/cv-processor/EnhancementsPage";

export default function EnhancementsRoute() {
  return <EnhancementsPage />;
}
